import gsap from "gsap";
import { isTablet } from './utils/breakpoints';

const 
default_options = {
    root: null,
    rootMargin: isTablet? '0px':'300px',
    threshold: isTablet? 0.15 : 0.75
};

export const createObserver = (options = default_options, callback) => {
  return new IntersectionObserver(function (entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Appeler le callback et lui passer l'élément cible et l'observateur
        callback(entry.target, observer);
        // Arrêter l'observation pour cet élément
        observer.unobserve(entry.target);
      }
    });
  }, options);
};
